import { h, clear } from '../ui/dom.js';
import { button, field, input, appFooter } from '../ui/components.js';
import { api, ApiError } from '../api.js';
import { setSession } from '../store.js';
import type { Page, PageContext } from '../page.js';
import type { Session } from '../types.js';

export async function loginPage(context: PageContext): Promise<Page> {
  const emailInput = input({
    type: 'email',
    placeholder: 'seu.email@exemplo.com',
    autocomplete: 'username',
    required: true,
  });
  const passwordInput = input({
    type: 'password',
    placeholder: '••••••••',
    autocomplete: 'current-password',
    required: true,
  });
  const errorSlot = h('div', { class: 'field__error' });
  const submitButton = button('Entrar no sistema', {
    block: true,
    size: 'lg',
    attrs: { type: 'submit' },
  });

  const submit = async (): Promise<void> => {
    clear(errorSlot);
    submitButton.disabled = true;
    submitButton.textContent = 'Verificando…';

    try {
      const session = await api.post<Session>('/api/auth/login', {
        email: emailInput.value.trim(),
        password: passwordInput.value,
      });
      setSession(session);
      context.navigate('/');
    } catch (error) {
      clear(errorSlot);
      errorSlot.textContent =
        error instanceof ApiError ? error.message : 'Não foi possível entrar. Tente novamente.';
      submitButton.disabled = false;
      submitButton.textContent = 'Entrar no sistema';
      passwordInput.value = '';
      passwordInput.focus();
    }
  };

  const form = h(
    'form',
    {
      class: 'auth__form',
      onsubmit: (event: Event) => {
        event.preventDefault();
        void submit();
      },
    },
    h(
      'div',
      null,
      h('div', { class: 'auth__title', text: 'Acessar o sistema' }),
      h('div', {
        class: 'muted small',
        style: { marginTop: '6px' },
        text: 'Use as credenciais fornecidas pela coordenação do encontro.',
      }),
    ),
    field({ label: 'E-mail', control: emailInput, required: true }),
    field({ label: 'Senha', control: passwordInput, required: true }),
    errorSlot,
    submitButton,
  );

  const aside = h(
    'div',
    { class: 'auth__aside' },
    h(
      'div',
      { class: 'auth__brand' },
      h('div', { class: 'sidebar__mark', text: 'FF' }),
      'Face a Face · Ministrações V2',
    ),
    h(
      'div',
      { class: 'stack' },
      h('div', { class: 'auth__headline', text: 'Do roteiro ao púlpito, tudo em um só lugar.' }),
      h(
        'div',
        { class: 'auth__features' },
        h(
          'div',
          { class: 'auth__feature' },
          h('span', { class: 'auth__feature-mark', text: '◈' }),
          'Modelos mestre com réplicas por edição do encontro',
        ),
        h(
          'div',
          { class: 'auth__feature' },
          h('span', { class: 'auth__feature-mark', text: '◈' }),
          'Repositório multimídia versionado por ministrador',
        ),
        h(
          'div',
          { class: 'auth__feature' },
          h('span', { class: 'auth__feature-mark', text: '◈' }),
          'Modo Púlpito com cronômetro e fila em tempo real',
        ),
        h(
          'div',
          { class: 'auth__feature' },
          h('span', { class: 'auth__feature-mark', text: '◈' }),
          'Painel de apoio para a equipe de mídia e som',
        ),
      ),
    ),
    h('div', {
      class: 'small',
      style: { color: '#8d8a83' },
      text: 'Acesso restrito · todas as ações são auditadas',
    }),
  );

  return {
    title: 'Entrar',
    fullBleed: true,
    body: h(
      'div',
      { class: 'auth' },
      aside,
      h('div', { class: 'auth__panel' }, h('div', { style: { width: 'min(400px, 100%)' } }, form, appFooter({ variant: 'auth' }))),
    ),
  };
}
